/**
 * Detects when a chat message describes a care transition worth pinning on
 * the roadmap. Deterministic keyword rules — the caregiver always confirms
 * with one tap, so precision beats cleverness. Order matters: more specific
 * event types are checked first.
 */
const RULES = [
    {
        event_type: "hospital", label: "Hospital or emergency visit",
        re: /\b(er\b|e\.r\.|emergency room|emergency visit|hospital|ambulance|admitted|discharg\w*|urgent care)\b/i,
    },
    {
        event_type: "medication", label: "Medication change",
        re: /\b(new (med|meds|medication|prescription)|medication (change|changed|started|stopped|switch\w*)|(changed|started|stopped|increased|decreased) (his|her|their|the|mom'?s|dad'?s) (med|meds|medication|dose)|dose (was )?(increased|decreased|changed)|prescribed)\b/i,
    },
    {
        event_type: "diagnosis", label: "New diagnosis",
        re: /\b(diagnos(ed|is)|got the results|neurolog\w* (said|confirmed)|mri (showed|results)|pet scan)\b/i,
    },
    {
        event_type: "move", label: "Move or living-arrangement change",
        re: /\b(mov(e|ed|ing) (in|out|to|her|him|them)|memory care|assisted living|nursing home|new facility|placement)\b/i,
    },
    {
        event_type: "service_ended", label: "Service ended",
        re: /\b((home health|hospice|respite|day program|aide|agency|service) (ended|stopped|quit|was cancelled|is over)|(lost|cancelled|stopped) (our|the|his|her) (aide|home health|respite|service))\b/i,
    },
    {
        event_type: "service_started", label: "Service started",
        re: /\b((home health|hospice|respite|day program|aide|agency|palliative) (started|starts|began|begins)|(started|hired) (a |an |our )?(new )?(aide|home health|respite|caregiver service))\b/i,
    },
    {
        event_type: "caregiver", label: "Caregiver change",
        re: /\b(new caregiver|hired (a |an )?(caregiver|aide)|(my|our) (sister|brother|husband|wife|son|daughter) (is|will be) (helping|taking over)|taking over (the )?care)\b/i,
    },
    {
        event_type: "safety", label: "Safety concern",
        re: /\b(got lost|wander(ed|ing)? (off|outside|away)|left the (stove|oven|door)|unsafe|still driving|car keys|gun|firearm)\b/i,
    },
    {
        event_type: "symptom", label: "New symptom or behavior",
        re: /\b(fell|fall(en|ing)?|new symptom|hallucinat\w*|sundown\w*|aggressi\w*|agitat\w*|stopped (eating|walking|talking|recognizing)|doesn'?t recognize|incontinen\w*)\b/i,
    },
];

export function detectTransition(text) {
    const t = String(text || "");
    if (t.length < 12) return null;
    for (const rule of RULES) {
        if (rule.re.test(t)) return { event_type: rule.event_type, label: rule.label };
    }
    return null;
}
